import DeleteImagesModal from './DeleteImagesModal'

export default DeleteImagesModal